import { useState } from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { Plus, Search } from 'lucide-react';
import { RenderIf } from '@/components/RenderIf';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import type { DashboardsOutletContext, DashboardsProps } from './types';
import {
    ContentContainer,
    DashboardsContainer,
    DashboardsContent,
    DashboardsHeader,
    HeaderRight,
    SearchContainer,
    SearchIcon,
} from './styled';

function Dashboards(_props: DashboardsProps) {
    const [shouldOpenCreateModal, setShouldOpenCreateModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const isOnListPage = useMatch('/agents/:agentId/dashboards');

    const outletContext: DashboardsOutletContext = {
        shouldOpenCreateModal,
        setShouldOpenCreateModal,
        searchQuery,
        setSearchQuery,
    };

    return (
        <DashboardsContainer>
            <DashboardsContent>
                <RenderIf isTrue={!!isOnListPage}>
                    <DashboardsHeader>
                        <HeaderRight>
                            <SearchContainer>
                                <SearchIcon>
                                    <Search size={18} />
                                </SearchIcon>
                                <Input
                                    type="text"
                                    placeholder="Search dashboards..."
                                    value={searchQuery}
                                    onChange={event => setSearchQuery(event.target.value)}
                                />
                            </SearchContainer>
                            <Button onClick={() => setShouldOpenCreateModal(true)}>
                                <Plus className="mr-2 h-4 w-4" />
                                New Dashboard
                            </Button>
                        </HeaderRight>
                    </DashboardsHeader>
                </RenderIf>
                <ContentContainer>
                    <Outlet context={outletContext} />
                </ContentContainer>
            </DashboardsContent>
        </DashboardsContainer>
    );
}

export default Dashboards;
